import { useState } from "react";

interface DemoPlayerProps {
  poster: string;
  title: string;
  episodes: string;
}

export default function DemoPlayer({ poster, title, episodes }: DemoPlayerProps) {
  const [notice, setNotice] = useState(false);

  return (
    <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
      <div className="relative w-full aspect-video bg-foreground-950">
        <img
          src={poster}
          alt={`${title} 播放演示画面`}
          title={`${title} 演示播放区域`}
          className="w-full h-full object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/30" />

        <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
          <button
            type="button"
            onClick={() => setNotice(true)}
            aria-label="播放演示"
            className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent-500 text-background-50 flex items-center justify-center cursor-pointer hover:bg-accent-600 transition-colors"
          >
            <i className="ri-play-fill text-3xl md:text-4xl w-8 h-8 flex items-center justify-center" />
          </button>
          <p className="mt-4 font-heading text-sm md:text-base font-bold text-background-50">
            本功能为展示示范，实际播放待接入
          </p>
          <p className="mt-1.5 text-[11px] md:text-xs text-background-100/65 max-w-md">
            当前播放器为前端演示组件，不加载任何真实视频流，也不提供下载服务。
          </p>
        </div>

        <div className="absolute left-3 top-3 px-2 py-0.5 rounded-md bg-foreground-950/70 backdrop-blur-sm text-[11px] font-label text-background-100">
          演示播放器
        </div>
        <div className="absolute right-3 top-3 flex items-center gap-1.5">
          <span className="px-2 py-0.5 rounded-md bg-foreground-950/70 backdrop-blur-sm text-[11px] font-label text-background-100">
            HD
          </span>
          <span className="px-2 py-0.5 rounded-md bg-foreground-950/70 backdrop-blur-sm text-[11px] font-label text-background-100">
            字幕 · 中日韩
          </span>
        </div>
      </div>

      <div className="px-4 py-3 flex items-center justify-between gap-3 flex-wrap border-t border-background-200">
        <div className="flex items-center gap-2 text-xs text-foreground-600">
          <i className="ri-information-line w-4 h-4 flex items-center justify-center text-foreground-400" />
          <span>{episodes}</span>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setNotice(true)}
            className="inline-flex items-center gap-1.5 h-8 px-3 rounded-md bg-background-100 text-[11px] font-label font-semibold text-foreground-700 hover:bg-background-200 whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-list-check w-3.5 h-3.5 flex items-center justify-center" />
            选集（演示）
          </button>
          <button
            type="button"
            onClick={() => setNotice(true)}
            className="inline-flex items-center gap-1.5 h-8 px-3 rounded-md bg-background-100 text-[11px] font-label font-semibold text-foreground-700 hover:bg-background-200 whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-fullscreen-line w-3.5 h-3.5 flex items-center justify-center" />
            全屏（演示）
          </button>
        </div>
      </div>

      {notice && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
          <button
            type="button"
            aria-label="关闭提示"
            onClick={() => setNotice(false)}
            className="absolute inset-0 bg-foreground-950/60 backdrop-blur-sm cursor-pointer"
          />
          <div className="relative w-full max-w-sm rounded-lg bg-background-50 border border-background-200 p-6 animate-fade-up">
            <div className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
              <i className="ri-movie-line text-xl w-5 h-5 flex items-center justify-center" />
            </div>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">播放功能暂未开放</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              本功能为展示示范，实际播放待接入。本站不提供真实播放接口与资源下载。
            </p>
            <button
              type="button"
              onClick={() => setNotice(false)}
              className="mt-5 w-full h-10 rounded-md bg-primary-600 text-background-50 text-sm font-label font-semibold hover:bg-primary-700 transition-colors cursor-pointer"
            >
              我知道了
            </button>
          </div>
        </div>
      )}
    </div>
  );
}